import { ArrowBack, ArrowDropDown, NavigateNext } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { useRef } from "react";
import Contributors from "../../../assets/meta.featured.json";
import PkCommonArrow from "../../../components/common/PkCommonArrow";
import { Apply } from "../apply/Apply";
function TheHeader({ show }) {
  return (
    <>
      <Typography variant="h6" sx={{ pr: 2.25 }}>
        {show.name}
      </Typography>
      <Box sx={{ pt: 1, pb: 3, display: "flex" }}>
        <Box
          sx={{
            mt: 0.75,
            height: "40px",
            borderLeft: 2,
            borderColor: "primary.main",
            opacity: 0.75,
          }}
        ></Box>
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ pl: 2.5, lineHeight: 1.75 }}
          >
            {show.text}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: (theme) => theme.palette.grey[600],
              pl: 2.5,
              lineHeight: 1.75,
            }}
          >
            {show.type}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
function TheFeature() {
  const [show, setShow] = React.useState(null);
  const ref0 = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  return (
    <Box ref={ref2} sx={{ pb: "4rem" }}>
      {show ? (
        <Box ref={ref0} data-aos="fade-left" data-aos-offset="100">
          <Card
            key={`${show.name}`}
            sx={{
              height: "100%",
              backgroundColor: (theme) => theme.palette.grey[900],
            }}
          >
            <Grid container>
              <Grid item xs={12} md={6}>
                <CardMedia
                  sx={{
                    maxHeight: `450px`,
                    borderBottom: 1,
                    borderColor: `#444`,
                  }}
                  component="img"
                  image={show.image}
                  src={show.image}
                  alt={show.name}
                />
                {/* <CardActions sx={{ pt: `2rem` }}>
                  <IconButton
                    sx={{ ml: 3 }}
                    onClick={() => {
                      ref0.current.classList.remove("aos-animate");
                      setTimeout(function () {
                        setShow(null);
                        setTimeout(function () {
                          ref1.current.classList.add("aos-animate");
                        }, 300);
                      }, 300);
                    }}
                  >
                    <ArrowBack
                      sx={{ color: "primary.main", fontSize: `1.75rem` }}
                    />
                  </IconButton>
                </CardActions> */}
                <CardContent sx={{ px: "2.5rem", pt: `2.5rem`, pb: 2 }}>
                  <TheHeader show={show} />
                </CardContent>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  borderLeft: 1,
                  borderColor: `#333`,
                }}
              >
                <CardContent sx={{ p: "0 2.5rem 0" }}>
                  <Box sx={{ textAlign: `center`, mt: -6, height: `100px` }}>
                    <ArrowDropDown
                      sx={{
                        color: `primary.main`,
                        fontSize: "7rem",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ lineHeight: 2 }}
                  >
                    {show.info}
                  </Typography>
                </CardContent>
                <CardActions sx={{ py: `2rem`, pt: `1rem` }}>
                  <IconButton
                    sx={{ ml: 3 }}
                    onClick={() => {
                      ref0.current.classList.remove("aos-animate");
                      setTimeout(function () {
                        setShow(null);
                        setTimeout(function () {
                          ref1.current.classList.add("aos-animate");
                        }, 300);
                      }, 300);
                    }}
                  >
                    <ArrowBack
                      sx={{ color: "primary.main", fontSize: `1.75rem` }}
                    />
                  </IconButton>
                </CardActions>
              </Grid>
            </Grid>
          </Card>
        </Box>
      ) : (
        <Box ref={ref1} data-aos="fade-right">
          {Contributors.map((s) => (
            <Card
              key={`${s.name}`}
              sx={{
                mb: 10,
                height: "100%",
                backgroundColor: (theme) => theme.palette.grey[900],
              }}
            >
              <CardMedia
                sx={{ maxHeight: `384px` }}
                component="img"
                image={s.banner}
                src={s.banner}
                alt={s.name}
              />
              <CardContent sx={{ p: "2.5rem 2.5rem 0" }}>
                <TheHeader show={s} />
              </CardContent>
              <CardActions>
                <Button
                  endIcon={<NavigateNext />}
                  sx={{
                    mb: 2,
                    ml: 3,
                    px: 0,
                    backgroundColor: "transparent",
                    color: "primary.main",
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    setTimeout(function () {
                      ref1.current.classList.remove("aos-animate");
                      setTimeout(function () {
                        setShow(s);
                        setTimeout(function () {
                          ref2.current.scrollIntoView();
                          ref0.current.classList.add("aos-animate");
                        }, 300);
                      }, 300);
                    }, 100);
                  }}
                >
                  LEARN MORE
                </Button>
              </CardActions>
            </Card>
          ))}
          <Box
            sx={{ p: `4rem 0 8rem`, display: "flex", justifyContent: "center" }}
          >
            <PkCommonArrow color={(theme) => `primary.main`} />
          </Box>
          <Apply />
        </Box>
      )}
    </Box>
  );
}
export function Featured() {
  return (
    <Box sx={{ backgroundColor: "white", p: `10rem 5% 5rem` }}>
      <TheFeature />
    </Box>
  );
}
